webpackJsonp([167818396323793],{

/***/ 744:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var React = __webpack_require__(1);
	var ReactRedux = __webpack_require__(14);
	var react_router_dom_1 = __webpack_require__(118);
	var TextField_1 = __webpack_require__(27);
	var RaisedButton_1 = __webpack_require__(32);
	var current_user_1 = __webpack_require__(19);
	var gears = __webpack_require__(174);
	var icon = __webpack_require__(172);
	var mapStateToProps = function mapStateToProps(state) {
	    return {
	        isRegistering: current_user_1.selectors.selectIsRegistering(state)
	    };
	};
	var mapDispatchToProps = {
	    register: current_user_1.actions.register
	};
	
	var RegisterStepComponent = function (_React$Component) {
	    _inherits(RegisterStepComponent, _React$Component);
	
	    function RegisterStepComponent() {
	        _classCallCheck(this, RegisterStepComponent);
	
	        var _this = _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	
	        _this.state = {
	            firstName: "",
	            lastName: "",
	            password: "",
	            email: ""
	        };
	        return _this;
	    }
	
	    RegisterStepComponent.prototype.onChangeFirstName = function onChangeFirstName(e) {
	        this.setState({ firstName: e.target.value });
	    };
	
	    RegisterStepComponent.prototype.onChangeLastName = function onChangeLastName(e) {
	        this.setState({ lastName: e.target.value });
	    };
	
	    RegisterStepComponent.prototype.onChangePassword = function onChangePassword(e) {
	        this.setState({ password: e.target.value });
	    };
	
	    RegisterStepComponent.prototype.onChangeEmail = function onChangeEmail(e) {
	        this.setState({ email: e.target.value });
	    };
	
	    RegisterStepComponent.prototype.componentWillReceiveProps = function componentWillReceiveProps(props) {
	        if (props.errorMessage !== "") {
	            this.setState({ errorVisible: true });
	        }
	        this.setState({ errorMessage: props.errorMessage });
	    };
	
	    RegisterStepComponent.prototype.register = function register() {
	        this.setState({ isRegistering: true });
	        this.props.register(this.state.email, this.state.firstName, this.state.lastName, this.state.password);
	    };
	
	    RegisterStepComponent.prototype.render = function render() {
	        var _this2 = this;
	
	        return React.createElement("div", { style: {
	                display: "flex",
	                flexDirection: "column",
	                justifyContent: "space-between",
	                alignItems: "center",
	                marginTop: "2rem",
	                position: "relative",
	                right: 0,
	                width: 440,
	                borderRadius: 3
	            } }, React.createElement(react_router_dom_1.Route, { render: function render(_ref) {
	                var history = _ref.history;
	                return React.createElement("img", { src: __webpack_require__(173), onClick: function onClick() {
	                        history.goBack();
	                    }, style: {
	                        position: "absolute",
	                        top: 25,
	                        left: 25,
	                        cursor: "pointer"
	                    } });
	            } }), React.createElement("img", { style: {
	                maxWidth: 75,
	                width: "100%",
	                marginBottom: "1rem"
	            }, src: this.props.isRegistering ? gears : icon }), React.createElement("form", { onSubmit: function onSubmit(e) {
	                e.preventDefault();
	                _this2.register.apply(_this2);
	            }, style: {
	                display: "flex",
	                flexDirection: "column",
	                alignItems: "center",
	                justifyContent: "space-between",
	                flex: 1
	            } }, React.createElement(TextField_1.default, { floatingLabelText: "First Name", type: "text", value: this.state.firstName, onChange: this.onChangeFirstName.bind(this), autoFocus: true, required: true }), React.createElement(TextField_1.default, { floatingLabelText: "Last Name", type: "text", value: this.state.lastName, onChange: this.onChangeLastName.bind(this), required: true }), React.createElement(TextField_1.default, { floatingLabelText: "Email", type: "email", value: this.state.email, onChange: this.onChangeEmail.bind(this), required: true }), React.createElement(TextField_1.default, { floatingLabelText: "Password", type: "password", value: this.state.password, onChange: this.onChangePassword.bind(this), style: {
	                marginBottom: "2rem"
	            }, required: true }), React.createElement(RaisedButton_1.default, { style: { width: "100%" }, label: "Register", type: "submit", disabled: this.props.isRegistering })));
	    };
	
	    return RegisterStepComponent;
	}(React.Component);
	
	exports.default = ReactRedux.connect(mapStateToProps, mapDispatchToProps)(RegisterStepComponent);

/***/ }),

/***/ 751:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var React = __webpack_require__(1);
	var ReactRedux = __webpack_require__(14);
	var Dialog_1 = __webpack_require__(47);
	var FlatButton_1 = __webpack_require__(48);
	var register_1 = __webpack_require__(744);
	var current_user_1 = __webpack_require__(19);
	var Heading_1 = __webpack_require__(40);
	var WithCurrentUser_1 = __webpack_require__(81);
	var mapStateToProps = function mapStateToProps(state) {
	    return {
	        registerErrorModalIsShowing: current_user_1.selectors.selectRegisterErrorModalIsShowing(state),
	        registerErrorCode: current_user_1.selectors.selectRegisterErrorCode(state)
	    };
	};
	var mapDispatchToProps = {
	    closeRegisterErrorModal: current_user_1.closeRegisterErrorModal
	};
	
	var RegisterPage = function (_React$Component) {
	    _inherits(RegisterPage, _React$Component);
	
	    function RegisterPage() {
	        _classCallCheck(this, RegisterPage);
	
	        return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	    }
	
	    RegisterPage.prototype.render = function render() {
	        return React.createElement("div", { style: {
	                display: "flex",
	                flexDirection: "column",
	                alignItems: "center"
	            } }, React.createElement(Heading_1.default, null, "Register"), React.createElement("p", { style: {
	                marginTop: "1em"
	            } }), React.createElement(register_1.default, null), React.createElement(Dialog_1.default, { title: "Error", actions: React.createElement(React.Fragment, null, React.createElement(FlatButton_1.default, { label: "Ok", primary: true, keyboardFocused: true, onClick: this.props.closeRegisterErrorModal.bind(this) })), modal: false, open: this.props.registerErrorModalIsShowing, onRequestClose: this.props.closeRegisterErrorModal.bind(this) }, this.props.registerErrorCode === "" ? "" : this.props.registerErrorCode === "INVALID_EMAIL" ? "You have entered an invalid email." : this.props.registerErrorCode === "TOKEN_UNAVAILABLE" ? "An account already exists for the provided email." : "An unexpected error occurred."));
	    };
	
	    return RegisterPage;
	}(React.Component);
	
	var RegisterPageAfterRedux = ReactRedux.connect(mapStateToProps, mapDispatchToProps)(RegisterPage);
	exports.default = function (props) {
	    return React.createElement(WithCurrentUser_1.default, null, function (user, userFetchStatus, a, b, isLoggedIn) {
	        return React.createElement(RegisterPageAfterRedux, _extends({ isLoggedIn: isLoggedIn }, props));
	    });
	};

/***/ }),

/***/ 173:
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,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"

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-register-tsx-832da251003320e0638b.js